<template>
      <div align="center" class="wrapper">
    <ContactUsHeader />
    <h4 v-if="hasBeenDisabledSignUp === 'ON'" class="text-center"><strong>Account creation is currently disabled. Please try again later.
      <br> If you have questions, contact our support at <a href="mailto:info@calvertimpact.org">info@calvertimpact.org</a> or 800.248.0337.</strong></h4>
    <h4 v-else class="text-center"><strong>Register to create a new investment account below</strong></h4>
    <div class="block-center mt-sm wd-xl">
            <p v-if="hasBeenDisabledSignUp === 'ON'" class="pt-sm text-center">
              If you are an existing investor,
                <router-link :to="{ name: 'Login' }">log in here</router-link> or email
                <a href="mailto:info@calvertimpact.org">info@calvertimpact.org</a> for online access.
            </p>
      <!-- START panel-->
      <div v-if="hasBeenDisabledSignUp === 'OFF'"  class="panel panel-dark panel-flat">
            <p class="pt-sm text-center">
              If you are an existing investor that has not logged in online before,
                <router-link :to="{ name: 'Login' }">log in here</router-link> or email
                <a href="mailto:info@calvertimpact.org">info@calvertimpact.org</a> for online access.
            </p>
        <div class="panel-body">
          <form role="form" class="mb-lg" @submit.prevent="validateAndSubmitRegistration" novalidate>
            <div class="form-group has-feedback" v-bind:class="{ 'has-error': emailError }">
              <label for="signupInputEmail1" class="text-muted">Email address</label>
              <input v-model="computedEmail" id="signupInputEmail1" type="email" placeholder="Enter email" autocomplete="off" required class="form-control">
              <em class="form-icon icon-envelope"></em>
              <span id="helpBlock2" class="help-block">{{ emailError }}</span>
            </div>

            <div class="form-group" v-bind:class="{ 'has-error': stateError }">
              <label for="state" class="text-muted">State</label>
              <select v-model="state" class="form-control" id="state" placeholder="Please select" required>
                <option value="" selected>Please select</option>
                <option v-for="s in filteredStates" :key="s.abbreviation" :value="s.abbreviation">{{s.name}}</option>
              </select>
              <span id="helpBlock3" class="help-block">{{ stateError }}</span>
            </div>

            <div class="form-group has-feedback" v-bind:class="{ 'has-error': passwordErrors.length > 0 }">
              <label for="signupInputPassword1" class="text-muted">Password</label>
              <input v-model="password" id="signupInputPassword1" type="password" placeholder="Password" autocomplete="off" required class="form-control">
              <em class="form-icon icon-lock"></em>
            </div>
            <PasswordHint :password="password" />
            <div class="form-group has-feedback" v-bind:class="{ 'has-error': passConfirmationError }">
              <label for="signupInputPassword1" class="text-muted">Confirm password</label>
              <input v-model="passwordConfirmation" id="signupInputPasswordConfirmation" type="password" placeholder="Confirm password" autocomplete="off" required class="form-control">
              <em class="form-icon icon-lock"></em>
              <span id="helpBlock5" class="help-block">{{ passConfirmationError }}</span>
            </div>
            <vue-recaptcha ref="recaptcha" @verify="onVerify" :sitekey="sitekey"></vue-recaptcha>
            <button type="submit" class="btn btn-block btn-default btn-lg mt-lg" :disabled="!recaptchaIsVerified">Create account</button>
            <div class="form-group has-feedback" v-bind:class="{ 'has-error': registrationError }">
              <strong id="helpBlock6" class="help-block">{{ registrationError }}</strong>
            </div>
          </form>


        </div>
      </div>
      <!-- END panel-->
    </div>
  </div>

</template>

<script>
  import {
    mapActions,
    mapState,
    mapMutations,
  } from 'vuex';
  import {
    SET_IDLE_OFF,
    SHOW_SUCCESS_MODAL,
  } from '@/store/mutation-types';
  import { auth as authConfig } from '@/config/config';
  import VueRecaptcha from 'vue-recaptcha';
  import {
    Constants,
  } from '../data/static/constants';
  import ContactUsHeader from './ContactUsHeader';
  import PasswordHint from './PasswordHint';
  import AddFundingSource from './AddFundingSource';

  export default {
    name: 'registration',
    beforeMount() {
      if (this.$route.query.email &&
          this.$route.query.message &&
          this.$route.query.success === 'true') {
        this.$router.push({
          path: 'login',
          query: this.$route.query,
        });
      }
      this.setIdleOff();
    },
    data() {
      return {
        recaptchaIsVerified: false,
        sitekey: authConfig.recaptchaSitekey,
        email: '',
        password: '',
        passwordConfirmation: '',
        state: '',
        recaptchaResponse: '',
        showPassword: false,
        emailError: '',
        passwordErrors: [],
        passConfirmationError: '',
        stateError: '',
        registrationError: '',
      };
    },
    computed: {
      ...mapState('app', [
        'hasBeenDisabledSignUp',
        'geoLocation',
      ]),
      filteredStates() {
        return this.geoLocation.states.filter(state => !state.onlyMailingAddress);
      },
      computedEmail: {
        get() {
          return this.email;
        },
        set(value) {
          this.email = value.toLowerCase();
        },
      },
    },
    components: {
      'vue-recaptcha': VueRecaptcha,
      ContactUsHeader,
      PasswordHint,
      AddFundingSource,
    },
    methods: {
      ...mapActions('authentication', [
        'register',
      ]),
      ...mapMutations('authentication', {
        setIdleOff: SET_IDLE_OFF,
      }),
      ...mapMutations('success', {
        showSuccessModal: SHOW_SUCCESS_MODAL,
      }),
      onVerify(response) {
        this.recaptchaResponse = response;
        this.recaptchaIsVerified = true;
      },
      resetValidations() {
        this.emailError = '';
        this.passwordErrors = [];
        this.passConfirmationError = '';
        this.stateError = '';
        this.registrationError = '';
      },
      validateAndSubmitRegistration() {
        this.resetValidations();
        const isEmailValid = this.validateEmail(this.email);
        const isStateValid = this.validateState(this.state);
        const isPasswordValid = this.validatePassword(this.password);
        const isPasswordConfirmationValid =
          this.validatePasswordConfirmation(this.password, this.passwordConfirmation);
        if (!isEmailValid || !isStateValid || !isPasswordValid
          || !isPasswordConfirmationValid || !this.recaptchaIsVerified) {
          return false;
        }
        const {
          email,
          password,
          state,
          recaptchaResponse,
        } = this;
        return this.register({
          email,
          password,
          state,
          recaptchaResponse,
        }).then((response) => {
          if (response.error) {
            this.registrationError = response.message;
          } else {
            this.showSuccessModal(Constants.registration.successMessage);
            this.$router.push({ name: 'Login' });
            window.dataLayer.push({
              event: 'registerAccount',
              userID: `new_user:${this.email}`,
            });
          }
        }).catch((response) => {
          if (response.error) {
            if (response.message.includes('If you entered a registered email in our system')) {
              this.emailError = response.message;
              return;
            }
            this.registrationError = response.message;
          }
        }).finally(() => {
          this.$refs.recaptcha.reset();
        });
      },
      validateEmail(email) {
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
        if (!regex.test(email)) {
          this.emailError = 'Please, enter a valid email';
          return false;
        }
        return true;
      },
      validatePassword(password) {
        if (password.length < 8) {
          this.passwordErrors.push('Password should have a minimum length of 8 characters');
        }
        if (!/[A-Z]/.test(password)) {
          this.passwordErrors.push('Password should have at least one uppercase letter');
        }
        if (!/[a-z]/.test(password)) {
          this.passwordErrors.push('Password should have at least one lowercase letter');
        }
        if (!/[0-9]/.test(password)) {
          this.passwordErrors.push('Password should have at least one number');
        }
        if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
          this.passwordErrors.push('Password should have at least one special character');
        }
        return this.passwordErrors.length === 0;
      },
      validatePasswordConfirmation(pass1, pass2) {
        if (pass1 !== pass2) {
          this.passConfirmationError = 'Passwords should match';
          return false;
        }
        return true;
      },
      validateState(state) {
        if (!state) {
          this.stateError = 'Please select a state';
          return false;
        }
        return true;
      },
    },
  };
</script>

<style>
  body {
    background-color: #fff;
  }

  /* Global mobile overrides - must be non-scoped to override theme.scss */
  @media (max-width: 1024px) {
    .wrapper {
      padding: 0 !important;
      margin: 0 !important;
      align-items: stretch !important;
    }

    .wrapper[align="center"] {
      display: flex !important;
      flex-direction: column !important;
      min-height: 100vh !important;
    }

    .block-center.mt-sm {
      margin: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
    }

    .block-center.mt-sm.wd-xl {
      margin: 0 !important;
      width: 100% !important;
    }

    .panel-dark.panel-flat {
      margin: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      flex: 1 !important;
    }
  }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wd-xl {
    width: 360px;
    max-width: 100%;
  }

  .show-password {
    cursor: pointer;
  }

  .text-red {
    color: #a94442;
  }

  .panel-body {
    padding: 15px 25px;
  }

  .form-icon {
    position: absolute;
    top: 34px;
    right: 12px;
  }

  /* Mobile responsive styles */
  @media (max-width: 1024px) {
    .wrapper > h4 {
      padding: 20px 24px !important;
      margin: 0 !important;
      font-size: 18px !important;
      line-height: 1.5 !important;
    }

    .wrapper > h4 strong {
      font-size: 18px !important;
    }

    .wrapper > h4 a {
      font-size: 16px !important;
    }

    .block-center.mt-sm > p {
      padding: 0 24px !important;
      font-size: 16px !important;
      margin-bottom: 16px !important;
    }

    .panel-body {
      padding: 30px 24px !important;
    }

    .pt-sm {
      padding-top: 16px !important;
    }

    label {
      font-size: 16px !important;
      margin-bottom: 8px !important;
    }

    .form-control {
      font-size: 18px !important;
      height: 50px !important;
      padding: 12px 16px !important;
    }

    select.form-control {
      font-size: 18px !important;
      height: 50px !important;
      padding: 12px 16px !important;
    }

    .form-icon {
      font-size: 18px !important;
      top: 43px !important;
      right: 16px !important;
    }

    .btn-lg {
      font-size: 20px !important;
      padding: 16px 24px !important;
      height: auto !important;
    }

    .mt-lg {
      margin-top: 20px !important;
    }

    .mb-lg {
      margin-bottom: 0;
    }

    .form-group {
      margin-bottom: 20px;
    }

    .help-block {
      font-size: 15px;
    }

    p {
      font-size: 16px;
      line-height: 1.5;
    }

    p a {
      font-size: 16px;
    }

    p.text-center {
      margin-bottom: 12px;
    }
  }

  @media (max-width: 480px) {
    .wrapper > h4 {
      padding: 18px 20px !important;
      font-size: 17px !important;
    }

    .wrapper > h4 strong {
      font-size: 17px !important;
    }

    .wrapper > h4 a {
      font-size: 15px !important;
    }

    .block-center.mt-sm > p {
      padding: 0 20px !important;
      font-size: 15px !important;
    }

    .panel-body {
      padding: 24px 20px !important;
    }

    label {
      font-size: 15px !important;
    }

    .form-control {
      font-size: 17px !important;
      height: 48px !important;
    }

    select.form-control {
      font-size: 17px !important;
      height: 48px !important;
    }

    .form-icon {
      font-size: 17px !important;
      top: 41px !important;
    }

    .btn-lg {
      font-size: 19px !important;
      padding: 15px 22px !important;
    }

    p {
      font-size: 15px;
    }

    p a {
      font-size: 15px;
    }
  }

  /* Extra small devices */
  @media (max-width: 360px) {
    .wrapper > h4 {
      padding: 16px 16px !important;
      font-size: 16px !important;
    }

    .wrapper > h4 strong {
      font-size: 16px !important;
    }

    .wrapper > h4 a {
      font-size: 14px !important;
    }

    .block-center.mt-sm > p {
      padding: 0 16px !important;
      font-size: 14px !important;
    }

    .panel-body {
      padding: 20px 16px !important;
    }

    label {
      font-size: 14px !important;
    }

    .form-control {
      font-size: 16px !important;
      height: 46px !important;
    }

    select.form-control {
      font-size: 16px !important;
      height: 46px !important;
    }

    .form-icon {
      font-size: 16px !important;
      top: 39px !important;
    }

    .btn-lg {
      font-size: 18px !important;
      padding: 14px 20px !important;
    }

    p {
      font-size: 14px;
    }

    p a {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// Registration.vue?54ee99ef